export default __webpack_public_path__ + "static/media/examples-phone-BG.4160eb79.png";